<div class="flex flex-col gap-1" [ngClass]="config.widthClass">
  <div id="{{config.widgetType ?? ''}}"
    class="relative"
    [ngClass]="[config.widthClass, config.heightClass]"
    role="progressbar"
    [attr.aria-valuemin]="0"
    [attr.aria-valuemax]="total"
    [attr.aria-valuenow]="value"
    [attr.aria-label]="resolvedAriaLabel"
  >
    <!-- Track + filled bar + target marker, all clipped to the same rounded pill box so the marker can never exceed the bar's height -->
    <div class="absolute inset-0 rounded-full overflow-hidden" [ngClass]="config.trackColorClass">
      <div class="absolute inset-y-0 left-0 rounded-full" [ngClass]="config.barColorClass" [style.width.%]="filledPercent"></div>

      <!-- Target marker line -->
      @if (showTarget) {
      <div
        class="absolute inset-y-0 w-0.5"
        [ngClass]="config.targetColorClass"
        [style.left.%]="targetPercent"
      ></div>
      }
    </div>
  </div>

  @if (config.showDisplayText || config.showSupportingText) {
  <div class="flex items-center justify-between gap-2">
    @if (config.showDisplayText) {
    <span class="font-medium whitespace-nowrap" [ngClass]="[displayTextSizeClass, config.textColorClass]">{{displayText}}</span>
    }
    @if (config.showSupportingText) {
    <span class="text-xs whitespace-nowrap" [ngClass]="config.textColorClass">{{supportingText}}</span>
    }
  </div>
  }

  <!-- Min / Current / Max labels -->
  @if (config.showMinMaxLabels) {
  <div class="flex items-center justify-between gap-2 text-xs" [ngClass]="config.textColorClass">
    <span>{{config.minLabel}}</span>
    <span class="font-medium">{{currentLabel}}</span>
    <span>{{maxLabel}}</span>
  </div>
  }
</div>
